import AvatarUploader from './avatar-uploader';

export default AvatarUploader;
